<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Adesão ao Plano</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Adesão ao Plano',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group" style="padding-right: 16px;">
                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-btn type="button" color="primary" elevation="0"
                                    to="/adesao-plano/graficos" v-on="on" v-bind="attrs">
                                    Gráficos por Classe
                                </v-btn>
                            </template>
                            <span>Visualizar gráficos detalhados por classe</span>
                        </v-tooltip>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card mb-4">
                    <v-card-title class="filter-card-title">
                        Filtros
                    </v-card-title>

                    <v-form @submit.prevent="load(true)">
                        <v-container>
                            <v-row>

                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined hide-details label="Nome"
                                        v-model="dataList.filter.name" @click:clear="clearNameSearch" />
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-text-field dense id="registration" label="CPF/CNPJ"
                                        v-model="dataList.filter.registration" hide-details outlined></v-text-field>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-select dense outlined clearable hide-details label="Status"
                                        :items="statusFilterOptions" item-text="text" item-value="value"
                                        v-model="dataList.filter.status" />
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-select dense outlined clearable hide-details label="Classe" :items="classOptions"
                                        item-text="text" item-value="value" v-model="filters.class"
                                        @change="filters.plan_option = null" />
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-select dense outlined clearable hide-details label="Opção de pagamento"
                                        :items="paymentOptions" item-text="text" item-value="value"
                                        v-model="filters.plan_option" :disabled="!filters.class" />
                                </v-col>

                            </v-row>

                            <v-row>
                                <v-col cols="auto" class="pr-4">
                                    <v-tooltip bottom>
                                        <template #activator="{ on, attrs }">
                                            <v-btn type="submit" color="primary" dark elevation="2" v-on="on"
                                                v-bind="attrs">
                                                Filtrar
                                            </v-btn>
                                        </template>
                                        <span>Filtrar dados</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col v-if="hasFilters()" cols="auto" class="pr-1">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" outlined color="primary" @click="clearFilters">
                                                Limpar
                                            </v-btn>
                                        </template>
                                        <span>Limpar filtros selecionados</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="table-card">

                    <v-card-title class="table-card-title d-flex align-center">
                        <span>Adesão ao Plano</span>
                        <v-spacer></v-spacer>

                        <div v-if="loadingExport" class="mr-4">
                            <v-progress-circular indeterminate color="primary" size="24" width="3" />
                        </div>

                        <div class="icon-container" @click="showModal = true">
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-icon v-on="on" size="x-large">
                                        mdi-microsoft-excel
                                    </v-icon>
                                </template>
                                <span>Exportar dados para CSV</span>
                            </v-tooltip>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhuma adesão foi encontrada" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.user.name`]="{ item }">
                                <span class="font-weight-bold">{{ item.user.name.toUpperCase() }}</span>
                            </template>

                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip small class="text-uppercase font-weight-bold text-caption"
                                    :color="getStatusColor(item.status)" label text-color="white">
                                    {{ getStatusLabel(item.status) }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.user.registration`]="{ item }">
                                {{ formatCpfCnpj(item.user.registration) }}
                            </template>

                            <template v-slot:[`item.updated_at`]="{ item }">
                                {{ item.updated_at ? $moment(item.updated_at, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss') : '' }}
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">

                                    <v-tooltip bottom>
                                        <template #activator="{ on, attrs }">
                                            <v-icon v-on="on" v-bind="attrs" :disabled="!$check(user, ['help.find'])"
                                                @click="viewItem(item)" size="large" class="me-2">
                                                mdi-pencil-outline
                                            </v-icon>
                                        </template>
                                        <span>Editar</span>
                                    </v-tooltip>

                                </v-row>
                            </template>

                        </v-data-table>
                    </v-card-text>

                </v-card>
            </v-col>
        </v-row>

        <!-- Modal exportar CSV-->
        <v-dialog v-model="showModal" max-width="600px">
            <v-card>
                <v-card-title class="card-title"
                    style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
                    EXPORTAR DADOS
                </v-card-title>
                <br>
                <v-card-text>

                    <p>Para realizar a pesquisa, é obrigatório informar a Data Inicial e a Data Final.</p>

                    <v-form ref="filterForm" @submit.prevent="loadCsvData">

                        <v-row>
                            <!-- Data Inicial -->
                            <v-col cols="12" md="6">
                                <v-menu v-model="menuStart" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y min-width="290px">
                                    <template #activator="{ attrs }">
                                        <v-text-field v-model="formattedStartDate" label="Data Inicial"
                                            placeholder="dd:mm:aaaa" prepend-icon="mdi-calendar" v-bind="attrs"
                                            inputmode="numeric" maxlength="10" pattern="[0-9\/]*"
                                            @keypress="onlyNumbers" @click:prepend="menuStart = true"
                                            @blur="updateStartDate" @input="onStartDateInput"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="csvFilters.startDate" locale="pt-BR" scrollable
                                        @input="formatStartDate" @change="menuStart = false"></v-date-picker>
                                </v-menu>
                            </v-col>

                            <!-- Data Final -->
                            <v-col cols="12" md="6">
                                <v-menu v-model="menuEnd" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y min-width="290px">
                                    <template #activator="{ attrs }">
                                        <v-text-field v-model="formattedEndDate" label="Data Final"
                                            placeholder="dd:mm:aaaa" prepend-icon="mdi-calendar" v-bind="attrs"
                                            inputmode="numeric" maxlength="10" pattern="[0-9\/]*"
                                            @keypress="onlyNumbers" @click:prepend="menuEnd = true"
                                            @blur="updateEndDate" @input="onEndDateInput"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="csvFilters.endDate" locale="pt-BR" scrollable
                                        @input="formatEndDate" @change="menuEnd = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>

                        <v-alert v-if="dateRangeError" type="warning" dense outlined class="mb-4">
                            O período selecionado não pode ultrapassar 5 dias.
                        </v-alert>

                        <br>
                        <v-row>
                            <!-- Hora Inicial -->
                            <v-col cols="12" md="6">
                                <v-menu v-model="menuStartTime" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y content-class="time-menu-adjust"
                                    max-width="290px">
                                    <template #activator="{ attrs }">
                                        <v-text-field v-model="formattedStartTime" label="Hora Inicial" pattern="[0-9]*"
                                            prepend-icon="mdi-clock-outline" v-bind="attrs" placeholder="HH:mm"
                                            maxlength="5" @input="onStartTimeInput" @blur="validateStartTime"
                                            @keypress="onlyNumbers" @click:prepend="menuStartTime = true" />
                                    </template>

                                    <v-time-picker v-model="csvFilters.startTime" format="24hr"
                                        @input="updateStartTimeFromPicker" @change="menuStartTime = false" />
                                </v-menu>
                            </v-col>

                            <!-- Hora Final -->
                            <v-col cols="12" md="6">
                                <v-menu v-model="menuEndTime" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y content-class="time-menu-adjust"
                                    max-width="290px">
                                    <template #activator="{ attrs }">
                                        <v-text-field v-model="formattedEndTime" label="Hora Final"
                                            prepend-icon="mdi-clock-outline" v-bind="attrs" placeholder="HH:mm"
                                            maxlength="5" @input="onEndTimeInput" @blur="validateEndTime"
                                            @click:prepend="menuEndTime = true" />
                                    </template>

                                    <v-time-picker v-model="csvFilters.endTime" format="24hr"
                                        @input="updateEndTimeFromPicker" @change="menuEndTime = false" />
                                </v-menu>
                            </v-col>

                        </v-row>

                        <v-alert v-if="timeRangeError" type="warning" dense outlined>
                            A hora final deve ser maior que a hora inicial.
                        </v-alert>

                        <br>
                        <v-row>
                            <v-spacer></v-spacer>
                            <v-btn text color="grey" @click="csvModalClose">Cancelar</v-btn>
                            <v-btn color="primary" type="submit" :disabled="isFilterDisabled"
                                :loading="loadingExport">Filtrar</v-btn>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import planAdherenceStatus from '@/common/data/plan-adherence-status.data'

import creditorTypes from "@/common/data/creditor-types.data.js";
//import eventStatus from "@/common/data/event-status.data";

import { cpf, cnpj } from 'cpf-cnpj-validator'

import object from "@/common/util/object"

Vue.use(VueLodash)

export default {
    name: "HelpList",

    data: () => ({
        user: null,
        showModal: false,
        menuStart: false,
        menuEnd: false,
        menuStartTime: false,
        menuEndTime: false,
        formattedStartDate: "",
        formattedEndDate: "",
        formattedStartTime: '',
        formattedEndTime: '',
        //dateRangeError: null,
        csvFilters: {
            startDate: null,
            endDate: null,
            startTime: null,
            endTime: null,
            importantCreditors: false,
            amount_plus: null,
            amount_minus: null,
            type: null,

        },
        filters: {
            class: null,
            plan_option: null
        },
        classOptions: [
            { text: 'Trabalhista', value: 1 },
            { text: 'Quirografário', value: 3 },
            { text: 'ME/EPP', value: 4 },
        ],
        planOptionText: {
            1: [
                { text: 'OPÇÃO A', value: 1 },
            ],
            3: [
                { text: 'OPÇÃO A', value: 1 },
                { text: 'OPÇÃO B', value: 2 },
                { text: 'OPÇÃO C', value: 3 },
                { text: 'OPÇÃO D', value: 4 },
                { text: 'OPÇÃO E', value: 5 },
            ],
            4: [
                { text: 'OPÇÃO A', value: 1 },
                { text: 'OPÇÃO B', value: 2 },
            ],
        },
        dataset: {
            data: {},
            planAdherenceStatus: planAdherenceStatus,
            creditorTypes: creditorTypes,
        },
        loadingExport: false,
        dataList: {
            filter: {
                name: "",
                registration: "",
                status: null,
            },
            headers: [
                { text: "Nome", value: "user.name" },
                { text: "CPF/CNPJ", value: "user.registration" },
                { text: "Status", value: "status" },
                { text: "Criado em", value: "created_at" },
                { text: "Atualizado em", value: "updated_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
        statusFilterOptions: [
            { text: 'Pendente', value: 0 },
            { text: 'Aprovado', value: 1 },
            { text: 'Rejeitado', value: 2 },
        ],
    }),

    computed: {
        isFilterDisabled() {
            if (!this.formattedStartDate || !this.formattedEndDate) {
                return true
            }

            return this.dateRangeError
        },

        dateRangeError() {
            if (!this.formattedStartDate || !this.formattedEndDate) {
                return false
            }

            if (this.formattedStartDate.length !== 10 || this.formattedEndDate.length !== 10) {
                return false
            }

            const days = this.diffInDays(
                this.formattedStartDate,
                this.formattedEndDate
            )

            return days > 5
        },

        timeRangeError() {
            if (!this.csvFilters.startTime || !this.csvFilters.endTime) return false

            return this.csvFilters.endTime < this.csvFilters.startTime
        },

        paymentOptions() {
            if (!this.filters.class) {
                return []
            }

            return this.planOptionText[this.filters.class] || []
        },

    },

    created() {
        this.load();
    },

    methods: {
        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.itemsPerPage = size;
            this.load(true);
        },

        hasFilters() {
            return Object.values(this.dataList.filter).some(value => value !== "" && value !== null && value !== undefined)
                || this.filters.class !== null
                || this.filters.plan_option !== null;
        },

        async clearFilters() {
            Object.keys(this.dataList.filter).forEach(key => {
                this.dataList.filter[key] = key === 'status' ? null : "";
            });

            this.filters.class = null
            this.filters.plan_option = null

            await this.load(true);
        },

        clearNameSearch() {
            this.dataList.filter.name = "";
            this.load(true);
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        formatStartTime(value) {
            this.formattedStartTime = value
        },

        formatEndTime(value) {
            this.formattedEndTime = value
        },

        updateStartTimeFromPicker(value) {
            this.formattedStartTime = value
            this.csvFilters.startTime = value
        },

        onStartTimeInput(value) {

            let numbers = value.replace(/\D/g, '')

            numbers = numbers.slice(0, 4)

            if (numbers.length >= 3) {
                this.formattedStartTime =
                    numbers.slice(0, 2) + ':' + numbers.slice(2)
            } else {
                this.formattedStartTime = numbers
            }

            this.csvFilters.startTime = this.formattedStartTime
        },

        validateStartTime() {
            if (this.isValidTime(this.formattedStartTime)) {
                this.csvFilters.startTime = this.formattedStartTime
            } else {
                this.formattedStartTime = ''
                this.csvFilters.startTime = null
            }
        },

        updateEndTimeFromPicker(value) {
            this.formattedEndTime = value
            this.csvFilters.endTime = value
        },

        onEndTimeInput(value) {
            let numbers = value.replace(/\D/g, '')

            numbers = numbers.slice(0, 4)

            if (numbers.length >= 3) {
                this.formattedEndTime =
                    numbers.slice(0, 2) + ':' + numbers.slice(2)
            } else {
                this.formattedEndTime = numbers
            }

            this.csvFilters.endTime = this.formattedEndTime
        },

        validateEndTime() {
            if (this.isValidTime(this.formattedEndTime)) {
                this.csvFilters.endTime = this.formattedEndTime
            } else {
                this.formattedEndTime = ''
                this.csvFilters.endTime = null
            }
        },

        isValidTime(value) {
            const regex = /^([01]\d|2[0-3]):([0-5]\d)$/
            return regex.test(value)
        },

        onStartDateInput(value) {

            let numbers = value.replace(/\D/g, '')

            numbers = numbers.slice(0, 8)

            if (numbers.length >= 5) {
                this.formattedStartDate =
                    numbers.slice(0, 2) + '/' +
                    numbers.slice(2, 4) + '/' +
                    numbers.slice(4)
            } else if (numbers.length >= 3) {
                this.formattedStartDate =
                    numbers.slice(0, 2) + '/' +
                    numbers.slice(2)
            } else {
                this.formattedStartDate = numbers
            }

            this.csvFilters.startDate = this.formattedStartDate
        },

        onEndDateInput(value) {

            let numbers = value.replace(/\D/g, '')

            numbers = numbers.slice(0, 8)

            if (numbers.length >= 5) {
                this.formattedEndDate =
                    numbers.slice(0, 2) + '/' +
                    numbers.slice(2, 4) + '/' +
                    numbers.slice(4)
            } else if (numbers.length >= 3) {
                this.formattedEndDate =
                    numbers.slice(0, 2) + '/' +
                    numbers.slice(2)
            } else {
                this.formattedEndDate = numbers
            }

            this.csvFilters.endDate = this.formattedEndDate
        },

        formatDate(date) {
            if (!date) return "";
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },

        parseDate(date) {
            if (!date) return null;
            const [day, month, year] = date.split("/");
            return `${year}-${month}-${day}`;
        },

        formatStartDate(date) {
            this.formattedStartDate = this.formatDate(date);
        },

        formatEndDate(date) {
            this.formattedEndDate = this.formatDate(date);
        },

        updateStartDate() {
            this.csvFilters.startDate = this.parseDate(this.formattedStartDate);
        },

        updateEndDate() {
            this.csvFilters.endDate = this.parseDate(this.formattedEndDate);
        },

        onlyNumbers(e) {
            const allowed = /[0-9/]/
            if (!allowed.test(e.key)) {
                e.preventDefault()
            }
        },

        diffInDays(start, end) {
            const [d1, m1, y1] = start.split('/')
            const [d2, m2, y2] = end.split('/')

            const startDate = new Date(y1, m1 - 1, d1)
            const endDate = new Date(y2, m2 - 1, d2)

            startDate.setHours(0, 0, 0, 0)
            endDate.setHours(0, 0, 0, 0)

            const diffTime = endDate - startDate

            return diffTime / (1000 * 60 * 60 * 24)
        },

        isDateRangeValid() {
            if (!this.csvFilters.startDate || !this.csvFilters.endDate) {
                return true
            }

            if (
                this.csvFilters.startDate.length !== 10 ||
                this.csvFilters.endDate.length !== 10
            ) {
                return true
            }

            const days = this.diffInDays(
                this.csvFilters.startDate,
                this.csvFilters.endDate
            )

            return days <= 5
        },

        async load(resetPage = false) {
            this.user = this.$root.user.data || this.$root.user;

            if (resetPage) {
                this.dataList.options.page = 1;
            }

            const rawFilters = {
                name: this.dataList.filter.name,
                registration: this.dataList.filter.registration,
                status: this.dataList.filter.status,
                class: this.filters.class,
                plan_option: this.filters.plan_option
            }

            const search = Object.fromEntries(
                Object.entries(rawFilters).filter(([_, v]) => v !== null && v !== undefined && v !== '')
            )

            //search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.itemsPerPage;

            const params = {
                page: this.dataList.options.page,
                limit: this.dataList.options.itemsPerPage,
                search: JSON.stringify(search)
            }

            try {
                const result = await axios.get('/api/admin/plan-adherence', { params });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000
                })
            } finally {
                this.dataList.loading = false;
            }

        },

        viewItem(item) {
            this.$router.push(`adesao-plano/${item.id}`);
        },

        // async deleteItem(item) {

        //     if (!item || !item.id) return;

        //     const proceedAction = await this.$dialog.confirm({
        //         text: 'Tem certeza que deseja continuar?',
        //         title: 'Excluir adesão ao plano',
        //         actions: {
        //             false: 'Cancelar',
        //             true: 'Excluir'
        //         }
        //     })

        //     if (!proceedAction) return;

        //     this.dataList.loading = true

        //     try {

        //         const result = await axios.delete(`/api/admin/helps/${item.id}`)

        //         this.$dialog.notify.info("Adesão ao plano excluída com sucesso!", { position: "top-right", timeout: 2000 });

        //         this.load()

        //     } catch (error) {

        //         this.$dialog.notify.error(this.$codes(error), {
        //             position: 'top-right',
        //             timeout: 2000
        //         })

        //     } finally {
        //         this.dataList.loading = false;
        //     }
        // },

        getStatusColor(status) {
            switch (status) {
                case 0:
                    return 'warning';
                case 1:
                    return 'accent';
                case 2:
                    return 'error';
                default:
                    return 'grey';
            }
        },

        getStatusLabel(status) {
            return (this.dataset.planAdherenceStatus.find(x => x.id === status) || {}).name || 'N/A';
        },

        formatCpfCnpj(value) {
            return value.length == 14 ? cnpj.format(value) : value.length == 11 ? cpf.format(value) : value;
        },

        async loadCsvData() {

            if (!this.formattedStartDate || !this.formattedEndDate) {
                this.$dialog.notify.error("Por favor, preencha os campos de data Inicial e Final!", { position: 'top-right', timeout: 5000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja exportar as adesões ao plano para CSV?',
                title: 'Exportar dados',
                actions: {
                    false: 'Cancelar',
                    true: 'Exportar'
                }
            })

            if (!proceedAction) return;

            const [startDay, startMonth, startYear] = this.formattedStartDate.split("/")//.map(Number);
            const [endDay, endMonth, endYear] = this.formattedEndDate.split("/");

            const startTime = this.formattedStartTime || "00:00";
            const endTime = this.formattedEndTime || "23:59";

            const startDateTime = `${startYear}-${startMonth.padStart(2, '0')}-${startDay.padStart(2, '0')} ${startTime}:00`;
            const endDateTime = `${endYear}-${endMonth.padStart(2, '0')}-${endDay.padStart(2, '0')} ${endTime}:59`;

            const startValidation = new Date(`${startYear}-${startMonth}-${startDay}T${startTime}:00`);
            const endValidation = new Date(`${endYear}-${endMonth}-${endDay}T${endTime}:59`);

            if (startValidation > endValidation) {
                this.$dialog.notify.error("A data/hora final deve ser maior que a inicial",
                    { position: 'top-right', timeout: 5000 }
                );
                return;
            }

            try {

                this.loadingExport = true;

                const result = await axios.get('/api/admin/plan-adherence', {
                    params: {
                        limit: 10000, search: {
                            updated_start: startDateTime,
                            updated_end: endDateTime
                        }
                    }
                });

                if (result.data.content.data.length == 0) {
                    this.$dialog.notify.error("Sem dados para gerar arquivo CSV!", { position: "top-right", timeout: 2000 });

                    return;
                }

                let newData = [];

                for (let item of result.data.content.data) {

                    let data = {
                        "NR ORDEM": item.id,
                        "CREDOR": item.user && item.user.name ? item.user.name : "N/A",
                        "CPF/CNPJ": item.user && item.user.registration ? this.formatCpfCnpj(item.user.registration) : "N/A",
                        "CLASSE": item.type ? (this.dataset.creditorTypes.find(type => type.id === item.type) || { name: "N/A" }).name : "N/A",
                        "OPÇÃO PAGAMENTO": this.getPlanOptionText(item.type, item.plan_option),
                        "ASSINADO POR": item.signer_name ? item.signer_name : "N/A",
                        "CPF ASSINANTE": item.signer_registration ? this.formatCpfCnpj(item.user.registration) : "N/A",
                        "ASSINADO EM": item.uploaded_at
                            ? this.$moment(item.uploaded_at, "YYYY-MM-DD HH:mm:ss")
                                .format("DD/MM/YYYY HH:mm:ss")
                            : "N/A",
                        "ATUALIZADO EM": item.updated_at
                            ? this.$moment(item.updated_at, "YYYY-MM-DD HH:mm:ss")
                                .format("DD/MM/YYYY HH:mm:ss")
                            : "N/A",
                        "STATUS": item.status !== null && item.status !== undefined
                            ? (this.dataset.planAdherenceStatus.find(status => status.id === item.status) || { name: "N/A" }).name
                            : "N/A",
                        "MOTIVO": item.validation_result ? item.validation_result : "N/A",
                    };

                    newData.push(data);

                }

                if (!newData.length) {
                    this.$dialog.notify.warning('Nenhuma informação de adesão ao plano foi encontrada!', {
                        position: 'top-right',
                        timeout: 2000
                    })
                    return;
                }

                const header = Object.keys(newData[0]);
                const csvContent = [header.join(';')];

                newData.forEach(item => {
                    const row = header.map(key => {
                        const value = item[key];
                        return typeof value === 'object' && value !== null ? value.join(';') : value;
                    }).join(';');
                    csvContent.push(row);
                });

                const csv = csvContent.join('\r\n');

                const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.setAttribute('href', url);

                const now = new Date();
                const date = now.toLocaleDateString('pt-BR').replace(/\//g, '-');
                const time = now.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }).replace(/:/g, '-');
                const fileName = `Adesao_${date}_${time}.csv`;

                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.$dialog.notify.info("Arquivo CSV gerado com sucesso!", { position: "top-right", timeout: 2000 });

            } catch (error) {
                console.log('error ', error.toString());
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.loadingExport = false;
                this.formattedStartDate = "";
                this.formattedEndDate = "";
                this.formattedStartTime = "";
                this.formattedEndTime = "";
                this.showModal = false;
            }
        },

        getPlanOptionText(type, planOption) {
            if (!type || !planOption) return 'N/A';

            const optionsByType = this.planOptionText[type];
            if (!optionsByType) return 'N/A';

            const option = optionsByType.find(opt => opt.value === planOption);
            return option ? option.text : 'N/A';
        },

        csvModalClose() {
            this.formattedStartDate = "";
            this.formattedEndDate = "";
            this.formattedStartTime = "";
            this.formattedEndTime = "";
            this.showModal = false;
        },


    },
};
</script>

<style>
.icon-container {
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 8px;
}

.time-menu-adjust {
    margin-top: 40px;
}
</style>
